import { BookingContext } from 'context/BookingContext';
import { useContext } from 'react';

const useBooking = () => {
  const context = useContext(BookingContext);

  if (!context) {
    throw new Error('useBooking must be used within a provider');
  }

  return context;
};

export default useBooking;
